@import '~@s-ui/theme/lib/settings-compat-v7/index';
@import '~@s-ui/theme/lib/index';
@import '~@adv-mt/mt-theme/lib/motor';

@import '~@adv-mt/mt-layout-basic/lib/index';
@import '~@adv-mt/mt-title-basic/lib/index';
@import '~@s-ui/react-molecule-input-field/lib/index';
@import '~@s-ui/react-atom-button/lib/index';
@import '~@s-ui/react-molecule-avatar/lib/index';
@import '~@s-ui/react-atom-spinner/lib/index';
@import '~@adv-mt/mt-svg-icons/lib/index';
@import '~@adv-mt/mt-modal-basic-content/lib/index';
@import '~@s-ui/react-molecule-modal/lib/index';

$bgi-path-login-container: 'login-container-bg-coches.jpg';

$mih-user-welcome: 115px;
$h-validation-icon: 64px;
$w-validation-icon: 64px;
$h-user-loading: 70vh;
$bgc-info-section: #000e2366;
$h-validation-section: 400px;
$c-neutral: #eef0f4 !default;

$w-modalContainer-desktop: 487px;

.mt-UserProfileComplete {
  &-main {
    align-items: normal;
    display: flex;
    flex-direction: column-reverse;
    gap: $g-xxl;
    text-align: left;

    @include media-breakpoint-up(s) {
      align-items: flex-start;
      flex-direction: row;
    }
  }

  &-loading {
    height: $h-user-loading;
  }

  &-loadingText {
    color: $c-black;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    top: 55%;
  }

  &-modalChildren {
    font-size: $fz-l;
    margin-bottom: $m-xl;
  }

  &-modalContainer {
    @include media-breakpoint-up(s) {
      width: $w-modalContainer-desktop;
    }
  }

  &-modalImage {
    margin-bottom: $m-l;
    width: 100%;
  }

  &-notification {
    position: fixed;
    bottom: 0;
    width: 100%;
    left: 0;

    @include media-breakpoint-up(l) {
      bottom: $m-xl;
      width: 96%;
      left: $m-xl;
    }
  }

  &-side {
    display: none;

    @include media-breakpoint-up(s) {
      display: flex;
    }
  }

  &-userForm {
    flex-grow: 1;
    gap: $g-m;

    & > *:first-child {
      margin-bottom: 0;
      @include media-breakpoint-up(s) {
        margin-bottom: $m-l;
      }
    }

    &Error {
      color: $c-error;
      font-size: $fz-s;
    }

    &WelcomeContainer {
      background-color: $c-neutral;
      border-radius: $bdrs-l;
      display: flex;
      flex-direction: column;
      margin: $m-xl 0;
      padding: $p-l;

      @include media-breakpoint-up(s) {
        margin: 0;
      }

      .mt-UserProfileComplete-userForm & {
        @include media-breakpoint-up(s) {
          display: none;
        }
      }
    }

    &WelcomeText {
      display: flex;
      flex-direction: column;
      margin: $m-m 0 0 $m-xl;
    }

    &WelcomeUserData {
      display: flex;
      margin-bottom: $m-l;
    }

    &WelcomeItem {
      margin-bottom: $m-s;
    }

    &WelcomeItem--bold {
      color: $c-black;
      font-weight: $fw-semi-bold;
      margin-bottom: $m-s;
    }

    &Button {
      margin-top: $m-xxl;
      width: 100%;

      @include media-breakpoint-up(l) {
        width: 30%;
      }
    }

    &Section {
      display: flex;
      flex-direction: column;
      flex-grow: 1;
      margin-top: $m-xxl;
    }

    &Section > div {
      margin-bottom: $m-l;
    }
  }

  &-userValidation {
    background-image: image-url('#{$bgi-path-login-container}');
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    margin-top: $m-l;
    padding: calc(#{$p-giant} * 2) 0;
  }

  &-userValidationContent {
    display: flex;
    border-radius: $bdrs-l;
    margin: 0 auto;
    overflow: hidden;
    width: 70%;
  }

  &-infoSection {
    color: $c-white;
    flex: 1;
    background-color: $bgc-info-section;
    padding: calc(#{$p-giant} * 2) $p-xl $p-xxxl;
    text-align: center;

    & > :nth-child(2) {
      margin-top: $m-xl;
    }
  }

  &-validationSection {
    background-color: $c-white;
    flex: 1;
    padding: $p-xxl $p-xl;
    @include media-breakpoint-up(l) {
      height: $h-validation-section;
    }
  }

  &-userValidationButton {
    margin-top: $m-xxl;
  }

  &-userValidationText {
    padding-right: $p-xl;
    margin: $m-xl 0 0 0;
  }

  &-validationIcon {
    align-items: center;
    background-color: $c-white;
    border-radius: 50%;
    display: flex;
    height: $h-validation-icon;
    justify-content: center;
    margin-right: $m-l;
    width: $w-validation-icon;
  }
}
